import React, { lazy, Suspense, useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { AnimatePresence, useReducedMotion } from 'framer-motion';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import PageLoader from '@/components/PageLoader';
import { routesConfig } from './RoutesConfig';

const Logout = lazy(() => import(/*webpackChunkName:'LogoutPage'*/ '@/pages/Logout'));
const NotFound = lazy(() => import(/*webpackChunkName:'NotFoundPage'*/ '@/pages/NotFound'));
const PrivacyPolicy = lazy(() => import(/*webpackChunkName:'PrivacyPolicyPage'*/ '@/pages/PrivacyPolicy'));

const SubMenuRouter = ({ subMenuRouter }) => {
  return subMenuRouter.map((subMenu) => (
    <PrivateRoute
      key={subMenu.component}
      path={subMenu.path}
      exact={subMenu.exact ?? true}
      component={lazy(() =>
        import(/* webpackChunkName: "[request]" */ `@/pages/${subMenu.component}`)
      )}
    />
  ));
};

export default function AppRouter() {
  const location = useLocation();
  const reduceMotion = useReducedMotion();
  const disableRouteAnimations =
    reduceMotion || process.env.REACT_APP_DISABLE_ROUTE_ANIMATIONS === 'true';

  useEffect(() => {
    console.log('[useLocation]', location.pathname);
  }, [location.pathname]);
  
  return (
    <Suspense fallback={<PageLoader />}>
      <AnimatePresence exitBeforeEnter={!disableRouteAnimations} initial={false}>
        <Switch location={location} key={location.pathname}>
          {routesConfig.map((routeItem) => {
            return (
              <PrivateRoute
                key={routeItem.component}
                path={routeItem.path}
                exact={routeItem.exact ?? true}
                component={lazy(() =>
                  import(/* webpackChunkName: "[request]" */ `@/pages/${routeItem.component}`)
                )}
              />
            );
          })}
          <Route path="/privacy-policy" component={PrivacyPolicy} exact />
          <PublicRoute path="/login" render={() => <Redirect to="/" />} exact />
          <Route component={Logout} path="/logout" exact />
          <Route path="*" component={NotFound} render={() => <Redirect to="/notfound" />} />
        </Switch>
      </AnimatePresence>
    </Suspense>
  );
}
